<template>
  <LayoutAutenticado>
    <div class="prestadores-dashboard fade-in-up">
      
      <!-- Header -->
      <header class="page-header">
        <div>
           <h1 class="page-title">Gerenciar Prestadores</h1>
           <p class="page-subtitle">Configure o acesso, identificação e áreas de atuação dos seus fornecedores em campo.</p>
        </div>
        <div class="header-actions">
           <AddPrestador label="Novo Prestador" @click="adicionarPrestador" />
        </div>
      </header>

      <!-- Grid de Prestadores -->
      <div v-if="listaDePrestadores.length > 0" class="providers-grid pb-5">
        <div v-for="(item, index) in listaDePrestadores" :key="index" class="provider-card">
          
          <!-- Card Header Visível -->
          <div class="card-header-bar">
             <div class="provider-avatar">
               <i class="bi bi-person-badge-fill"></i>
             </div>
             <div class="provider-title">
               <h4>{{ item.nomePrestador }}</h4>
               <span class="badge-status" :class="item.status ? 'active' : 'inactive'">
                 {{ item.status ? 'Ativo' : 'Inativo' }}
               </span>
             </div>
          </div>

          <!-- Campos do Prestador -->
          <div class="card-body-section">
            <div class="form-group">
              <label>Nome Completo</label>
              <div class="input-wrapper">
                 <i class="bi bi-person icon"></i>
                 <input v-model="item.nomePrestador" type="text" class="form-control" />
              </div>
            </div>

            <div class="row-flex">
              <div class="form-group flex-1">
                <label>QRA</label>
                <div class="input-wrapper locked">
                   <i class="bi bi-person-vcard icon"></i>
                   <input v-model="item.qra" type="text" class="form-control" disabled />
                </div>
              </div>
              <div class="form-group flex-1">
                <label>CPF</label>
                <div class="input-wrapper">
                   <i class="bi bi-fingerprint icon text-primary"></i>
                   <input v-model="item.cpf" type="text" class="form-control" @input="formatCPF($event, item)" />
                </div>
              </div>
            </div>

            <div class="row-flex">
              <div class="form-group flex-1">
                <label>Viatura (Placa/Mod)</label>
                <div class="input-wrapper">
                   <i class="bi bi-car-front-fill icon text-warning"></i>
                   <input v-model="item.viatura" type="text" class="form-control" />
                </div>
              </div>
              <div class="form-group flex-1">
                <label>Telefone</label>
                <div class="input-wrapper">
                   <i class="bi bi-telephone text-success icon"></i>
                   <input v-model="item.telefone" type="text" class="form-control" @input="formatPhone($event, item)" />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>Região de Cobertura</label>
              <div class="input-wrapper">
                 <i class="bi bi-geo-alt icon"></i>
                 <input v-model="item.regiao" type="text" class="form-control" placeholder="Zona, Bairros, Cidades..." />
              </div>
            </div>

            <div class="card-footer-actions row-flex mt-2">
               <div class="form-group flex-1">
                 <label>Perfil de Acesso</label>
                 <div class="select-wrapper default-border">
                   <select class="form-select" v-model="perfisSelecionados[item.qra]" @change="item.profileValueId = perfisSelecionados[item.qra]">
                     <option disabled value="">Selecionar Perfil</option>
                     <option v-for="profile in listaDeProfiles" :key="profile.id" :value="profile.id">
                       {{ profile.name }}
                     </option>
                   </select>
                   <i class="bi bi-chevron-down select-icon"></i>
                 </div>
               </div>

               <div class="form-group" style="align-items: flex-end;">
                  <label>Status de Operação</label>
                  <label class="modern-switch">
                    <input type="checkbox" v-model="item.status" />
                    <span class="slider"></span>
                  </label>
               </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estado Vazio -->
      <div v-else class="empty-state">
         <div class="empty-icon"><i class="bi bi-person-x"></i></div>
         <h3>Nenhum Prestador Encontrado</h3>
         <p>Parece que você ainda não adicionou fornecedores de serviço.</p>
         <AddPrestador label="Adicionar Primeiro Prestador" @click="adicionarPrestador" class="mt-3" />
      </div>

    </div>

    <!-- Posição fixa do Botão Salvar Global -->
    <div v-if="listaDePrestadores.length > 0" class="floating-save-container">
      <BotaoSalvar @click="editPrestadores" />
    </div>

    <!-- Modal Novo Prestador V2 -->
    <Modal :isVisible="isNewUser" @close="isNewUser = false">
      <div class="modal-header-v2">
         <h3>Novo Prestador em Campo</h3>
         <button class="close-btn" @click="isNewUser = false"><i class="bi bi-x-lg"></i></button>
      </div>
      
      <div class="modal-body-v2">
         <div class="form-grid">
            <div class="form-group full-width">
              <label>Nome Completo</label>
              <div class="input-wrapper">
                <i class="bi bi-person-bounding-box icon"></i>
                <input v-model="newNome" type="text" class="form-control" placeholder="Digite o nome completo" />
              </div>
            </div>

            <div class="form-group">
              <label>QRA (Código)</label>
              <div class="input-wrapper">
                <i class="bi bi-upc-scan icon text-primary"></i>
                <input v-model="newQra" type="text" class="form-control" placeholder="1054..." />
              </div>
            </div>

            <div class="form-group">
              <label>CPF</label>
              <div class="input-wrapper">
                <i class="bi bi-fingerprint icon text-secondary"></i>
                <input v-model="newCPF" type="text" class="form-control" @input="formatCPF($event)" placeholder="000.000.000-00" />
              </div>
            </div>

            <div class="form-group">
              <label>Viatura</label>
              <div class="input-wrapper">
                <i class="bi bi-car-front-fill icon text-warning"></i>
                <input v-model="newViatura" type="text" class="form-control" placeholder="Placa / Veículo" />
              </div>
            </div>

            <div class="form-group">
              <label>Telefone</label>
              <div class="input-wrapper">
                <i class="bi bi-telephone-fill icon text-success"></i>
                <input v-model="newTelefone" type="text" class="form-control" @input="formatPhone($event)" placeholder="(00) 00000-0000" />
              </div>
            </div>

            <div class="form-group full-width">
              <label>Região de Cobertura</label>
              <div class="input-wrapper">
                <i class="bi bi-geo-alt-fill icon"></i>
                <input v-model="newRegioes" type="text" class="form-control" placeholder="Separe por vírgulas" />
              </div>
            </div>

            <div class="form-group full-width">
              <label>Perfil Assinalado</label>
              <div class="select-wrapper default-border">
                <select v-model="perfisSelecionados[newQra]" class="form-select">
                  <option disabled value="">Role/Perfil de Acesso</option>
                  <option v-for="profile in listaDeProfiles" :key="profile.id" :value="profile.id">
                    {{ profile.name }}
                  </option>
                </select>
                <i class="bi bi-chevron-down select-icon"></i>
              </div>
            </div>
         </div>
      </div>

      <div class="modal-footer-v2">
         <button class="btn-cancel" @click="isNewUser = false">Cancelar</button>
         <BotaoSalvar @click="saveNewUsers" />
      </div>
    </Modal>

    <!-- Toasts -->
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
      <div id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
          <i class="bi bi-info-circle-fill text-primary me-2"></i>
          <strong class="me-auto">Atualização do Sistema</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body" id="toastBody">
          Aqui aparecerá a mensagem.
        </div>
      </div>
    </div>
  </LayoutAutenticado>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import LayoutAutenticado from '../components/layouts/LayoutAutenticado.vue';
import axios from '@/axios.js';
import BotaoSalvar from '../components/ui/BotaoSalvar.vue';
import { showToast } from '@/eventBus.js';
import Modal from '@/components/Modal.vue';
import AddPrestador from '../components/ui/BtnAdicionar.vue';

const listaDePrestadores = ref([]);
const listaDeProfiles = ref([]);
const perfisSelecionados = ref({});
const isNewUser = ref(false);
const newNome = ref('');
const newCPF = ref('');
const newQra = ref('');
const newViatura = ref('');
const newTelefone = ref('');
const newRegioes = ref('');
const newPerfil = ref('');
const perfil = ref([]);

onMounted(() => {
  const companyId = localStorage.getItem("idCompany");
  
  axios.get(`/api/prestadores/all/${companyId}`)
    .then(response => {
      listaDePrestadores.value = response.data.data.sort((a, b) => {
        if (a.status === b.status) return 0;
        return a.status ? -1 : 1;
      });

      listaDePrestadores.value.forEach(prestador => {
        perfisSelecionados.value[prestador.qra] = prestador.profileValueId || "";
      });

      if (listaDePrestadores.value.length > 0 && listaDePrestadores.value[0].profileValueId) {
        perfil.value = listaDePrestadores.value[0].profileValueId;
      }
    })
    .catch(error => {
      showToast(error?.response?.data?.message || "Erro na consulta de prestadores");
    });

  // Fetch profiles
  axios.get(`/api/profile-value/basic/${companyId}`).then(response => {
    listaDeProfiles.value = response.data.data;
  }).catch(error => {
    showToast(error?.response?.data?.message || "Erro ao consultar perfis básicos")
  });
});

function adicionarPrestador() {
  isNewUser.value = true;
}

async function editPrestadores() {
  const companyId = localStorage.getItem("idCompany");

  // Validate CPFs
  for (const prestador of listaDePrestadores.value) {
    if (!isValidCPF(prestador.cpf)) {
      showToast(`CPF inválido para o prestador: ${prestador.nomePrestador}`);
      return;
    }
  }

  await axios.put(`/api/prestadores/edit/${companyId}`, listaDePrestadores.value)
    .then(response => {
      showToast(response.data.message);
      listaDePrestadores.value = response.data.data;

      const novosPerfis = {};
      listaDePrestadores.value.forEach(prestador => {
        novosPerfis[prestador.qra] = prestador.profileValueId || "";
      });
      perfisSelecionados.value = novosPerfis;
    })
    .catch(error => {
      showToast(error?.response?.data?.message || "Falha ao salvar múltiplos prestadores.");
    });
}

function isValidCPF(cpf) {
  cpf = (cpf || '').replace(/[^\d]+/g, ''); 
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  let soma = 0, resto;
  for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(cpf.substring(10, 11));
}

function saveNewUsers() {
  const companyId = localStorage.getItem("idCompany");

  if (!isValidCPF(newCPF.value)) {
    showToast("CPF inválido. Por favor, insira um CPF válido da Receita Federal.");
    return;
  }

  const arrayTelefone = newTelefone.value.split(';').map(item => item.trim());
  const arrayRegioes = newRegioes.value.split(';').map(item => item.trim());

  const data = {
    companyId: companyId,
    nomePrestador: newNome.value,
    viatura: newViatura.value,
    qra: newQra.value,
    cpf: newCPF.value,
    regiao: arrayRegioes,
    telefone: arrayTelefone,
    status: true,
    profileValueId: perfisSelecionados.value[newQra.value] || "",
  };

  axios.post(`/api/prestadores/${companyId}`, data)
    .then(response => {
      isNewUser.value = false;
      showToast(response.data.message || "Sucesso");
    })
    .catch(error => {
      showToast(error?.response?.data?.message || "Erro de integridade do servidor");
    });
}

function formatCPF(event, item) {
  const value = event && event.target && typeof event.target.value === 'string'
    ? event.target.value
    : (typeof event === 'string' ? event : '');

  const raw = value.replace(/\D/g, '').slice(0, 11);
  const formatted = raw
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  if (item && Object.prototype.hasOwnProperty.call(item, 'cpf')) {
    item.cpf = formatted;
  } else {
    newCPF.value = formatted;
  }
}

function formatPhone(event, item) {
  const value = event && event.target && typeof event.target.value === 'string'
    ? event.target.value
    : (typeof event === 'string' ? event : '');

  const raw = value.replace(/\D/g, '').slice(0, 11); 
  let formatted = raw;

  if (raw.length <= 10) {
    formatted = raw
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    formatted = raw
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2');
  }

  if (item && Object.prototype.hasOwnProperty.call(item, 'telefone')) {
    item.telefone = formatted;
  } else {
    newTelefone.value = formatted;
  }
}

const filteredProfiles = computed(() => {
  return listaDeProfiles.value.filter(profile => profile.id !== perfil.value);
});

watch(listaDeProfiles.value, (newVal) => {
  if (perfil.value && !newVal.some(profile => profile.id === perfil.value)) {
    perfil.value = null;
  }
});
</script>

<style scoped>
/* Page Layout Params */
.prestadores-dashboard {
  width: 100%;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.page-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1E293B;
  margin-bottom: 0.25rem;
}

.page-subtitle {
  font-size: 0.95rem;
  color: #64748B;
  margin: 0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  background: #FFF;
  border-radius: 16px;
  border: 1px dashed #CBD5E1;
  color: #64748B;
}

.empty-icon {
  font-size: 3rem;
  color: #94A3B8;
  margin-bottom: 1rem;
  opacity: 0.5;
}

/* Base Provider grid */
.providers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 1.5rem;
}

.provider-card {
  background: #FFFFFF;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.02);
  display: flex;
  flex-direction: column;
  transition: all 0.2s ease;
}

.provider-card:hover {
  box-shadow: 0 8px 16px rgba(0,0,0,0.04);
  border-color: #CBD5E1;
}

/* Provider Header Profile */
.card-header-bar {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #F1F5F9;
  padding-bottom: 1.25rem;
}

.provider-avatar {
  font-size: 2.25rem;
  color: #94A3B8;
  background: #F8FAFC;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.provider-title h4 {
  margin: 0;
  font-weight: 700;
  color: #0F172A;
  font-size: 1.05rem;
}

.badge-status {
  display: inline-block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
}

.badge-status.active {
  background-color: #DCFCE7;
  color: #16A34A;
}

.badge-status.inactive {
  background-color: #F1F5F9;
  color: #64748B;
}

/* Card Form Core */
.card-body-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.85rem;
}

.row-flex {
  display: flex;
  gap: 1rem;
}

.flex-1 {
  flex: 1;
}

/* Setup wrapper */
.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
}

.input-wrapper.locked {
  background-color: #F1F5F9;
  opacity: 0.8;
  cursor: not-allowed;
}

.input-wrapper .icon {
  font-size: 1.15rem;
  color: #94A3B8;
  margin-right: 0.5rem;
}

.text-primary { color: #3B82F6 !important; }
.text-warning { color: #F59E0B !important; }
.text-success { color: #10B981 !important; }

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: 0.95rem;
  color: #1E293B;
  outline: none;
  min-width: 0; 
}

.form-control::placeholder {
  color: #CBD5E1;
}

/* Specialized Selects */
.select-wrapper {
  position: relative;
}
.select-wrapper.default-border {
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 0.5rem 1rem;
}
.select-wrapper.default-border:focus-within {
  border-color: #DF523A;
  background-color: #FFF;
}

.form-select {
  width: 100%;
  appearance: none;
  background: transparent;
  border: none;
  font-family: inherit;
  font-weight: 600;
  color: #334155;
  font-size: 0.9rem;
  outline: none;
  cursor: pointer;
  padding-right: 20px;
}

.select-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  pointer-events: none;
}

/* Modern Switch */
.modern-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.modern-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #CBD5E1;
  transition: .3s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .3s;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

input:checked + .slider {
  background-color: #10B981; 
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Floating Save Actions */
.floating-save-container {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 99;
}

/* Modal UI overrides */
.modal-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid #E2E8F0;
  margin-bottom: 1.5rem;
}

.modal-header-v2 h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  color: #0F172A;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.25rem;
  color: #94A3B8;
  cursor: pointer;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #EF4444;
}

.modal-body-v2 .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

.modal-body-v2 .form-group.full-width {
  grid-column: 1 / -1;
}

.modal-footer-v2 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #E2E8F0;
}

.btn-cancel {
  background: transparent;
  border: none;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  padding: 0.5rem 1rem;
  transition: color 0.2s;
}
.btn-cancel:hover {
  color: #0F172A;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-in-up {
  animation: fadeInUp 0.5s ease forwards;
}

@media (max-width: 767.98px) {
  .providers-grid {
    grid-template-columns: 1fr;
  }
  .row-flex {
    flex-direction: column;
    gap: 1rem;
  }
  .modal-body-v2 .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
